import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody } from '../../../../components/card/card';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../components/Shared/Loader/Loading';
import NeatixModal from '../../../../components/Modal/NeatixModal';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { getDynamicFormLettersList } from '../../../../store/NTX/PrintTemplate/PrintTemplateSlice';
import MngTemplates from '../PrintingForms/MngTemplates';

function Index() {
  const { HasPermission } = usePermissions();
  const dispatch = useAppDispatch();

  const [templateId, setTemplateId] = useState<string>('');
  const { t, i18n } = useTranslation();

  const [show, setShow] = useState(false);

  // const { DynamicFormAme } = useGetDynamicForm();

  const { DynamicFormLettersList, loading, error } = useAppSelector((state) => state.PrintTemplate);
  useEffect(() => {
    dispatch(getDynamicFormLettersList());
  }, [dispatch]);

  //__________________________________________________

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Application'), key: 'barcode' },
    { title: t('Icon'), key: 'Category' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false },
  ];

  const tableData = DynamicFormLettersList?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      barcode: i18n.language === 'ar' ? item.moduleName2 : item.moduleName,
      Category: (
        <div className="text-theme fs-4">
          <i className={item.icon}></i>
        </div>
      ),
      action: (
        <>
          {HasPermission('NtxPrintingFormsLetterSetting') && (
            <button
              hidden={item.printTemplateId === null}
              type="button"
              className="btn btn-outline-theme ms-1"
              onClick={() => {
                setTemplateId(item.printTemplateId);
                setShow(true);
              }}>
              <i className=" text-theme fa-lg fa-fw me-1 bi bi-file-earmark-text"></i>
              {t('TemplateSettings')}
            </button>
          )}

          {HasPermission('NtxAddEditPrintingFormsLetter') && (
            <>
              <button
                hidden={item.printTemplateId !== null}
                type="button"
                className="btn btn-outline-theme ms-1"
                onClick={() => {
                  const newLocation = `PrintingFormsLetter/${item.id}/AddPrintingFormsLetter`;

                  window.location.href = newLocation;
                }}>
                <>
                  <i className="fa fa-plus-circle fa-fw me-1"></i>
                  {t('Add')}
                </>
              </button>
              <button
                hidden={item.printTemplateId === null}
                type="button"
                className="btn btn-outline-theme ms-1"
                onClick={() => {
                  const newLocation = `PrintingFormsLetter/${item.printTemplateId}/UpdatePrintingFormsLetter`;
                  window.location.href = newLocation;
                }}>
                <i className="far fa-lg fa-fw me-1  fa-edit"></i>
                {t('Edit')}
              </button>
            </>
          )}
        </>
      ),
    };
  });

  //____________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: t('LetterManagement'),
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('LetterManagement')} />
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <NeatixModal show={show} setShow={setShow} size="xl" bodyClassName="p-2" showHeader={false}>
        {templateId && <MngTemplates templateId={templateId} onClose={() => setShow(false)} />}
      </NeatixModal>

      {/* <NeatixModal
        show={showModal}
        setShow={setShowModal}
        size="lg"
        bodyClassName="p-2"
        showHeader={false}>
        <Notes />
      </NeatixModal> */}
    </>
  );
}

export default Index;
